<div class="modal-header card-header">
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="cerrar()">×</button>
</div>

<app-cargando *ngIf="cargando"></app-cargando>

<div class="row">
  <div class="col-12">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">{{titulo}}</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body">

              <div class="row">

                  <div class="columns col-12">
                  <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns" ></ngx-table>

                    <ng-template #frmSeleccionar let-row let-rowIndex="rowIndex">
                        <!--<a href="/Layoult/Venta/{{row.DocEntry}}/{{ObjTypeDoc}}" target="_blank">{{row.DocNum}}</a>-->
                        <button class="btn btn-info btn-sm" (click)="seleccionar(row)">Seleccionar</button>
                    </ng-template>

                    <ng-template #frmNumeroDocumento let-row let-rowIndex="rowIndex">
                        <!--<a href="/Layoult/Venta/{{row.DocEntry}}/{{ObjTypeDoc}}" target="_blank">{{row.DocNum}}</a>-->
                        <button class="btn btn-info btn-sm" (click)="abrirLayout(row)">{{row.DocNum}}</button>
                    </ng-template>

                    <ng-template #frmEstado let-row let-rowIndex="rowIndex" >
                        <span class="badge badge-primary" *ngIf="row.DocStatus=='O'">Abierta</span>
                        <span class="badge badge-danger" *ngIf="row.DocStatus=='C'">Cerrada</span>
                    </ng-template>

                    <ng-template #frmVendedor let-row let-rowIndex="rowIndex">
                        {{this.vendedorCodigoATexto(row.SlpCode)}}
                    </ng-template>

                    <ng-template #frmFechaDocumento let-row let-rowIndex="rowIndex">
                        {{row.DocDate | date: 'dd/MM/yyyy'}}
                    </ng-template>

                    <ng-template #frmFechaEntrega let-row let-rowIndex="rowIndex">
                        {{row.DocDueDate | date: 'dd/MM/yyyy'}}
                    </ng-template>

              </div>
              </div>

          </div>
      </div>
  </div>
</div>
